import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Card from "../../../components/Card";
import { getApiCall } from "../../../service/httpCall";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { LICENCE_HISTORY_LIST } from "../../../service/url";
import Loader from "../../../components/partials/components/loader";
import exportData from "../../../utilities/export";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { errorCheck } from "../auth/auth-utils";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import "../../../assets/custom/css/custom.css";
import { LICENCE_LABEL } from "../../../utilities/constant";

export default function LicenceHistoryList() {
  const navigate = useNavigate();
  const [operationList, setOperationList] = useState([]);
  const [originalDataList, setOriginalDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const handleExport = async () => {
    setButtonDisable(true);
    await exportData("LicenceHistory", setToastProps, setShowToast);
    setButtonDisable(false);
  };

  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);

  useEffect(() => {
    setLoading(true);
    getApiCall(LICENCE_HISTORY_LIST)
      .then(onOperationListSuccess)
      .catch(onError)
      .finally(() => setLoading(false));
  }, []);

  function onOperationListSuccess(resp) {
    const updatedList = resp.map((val, idx) => {
      return {
        ...val,
        key: idx + 1,
        created_at_formatted: new Date(val.created_at).toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }),
      };
    });

    setOperationList(updatedList);
    setOriginalDataList(updatedList);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const licenceChangeBody = (rowData) => {
    const oldLic = rowData.old_licence || {};
    const newLic = rowData.updated_licence || {};

    return (
      <div style={{ fontSize: "13px", lineHeight: "1.6" }}>
        {Object.keys(LICENCE_LABEL).map((key) => {
          const oldVal = oldLic[key] ?? 0;
          const newVal = newLic[key] ?? 0;

          return (
            <div key={key}>
              <strong>{LICENCE_LABEL[key]}:</strong>{" "}
              <span style={{ color: "red" }}>{oldVal}</span> →{" "}
              <span style={{ color: "green" }}>{newVal}</span>
            </div>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    if (!searchValue.trim()) {
      setOperationList(originalDataList);
      return;
    }

    const lowerSearch = searchValue.toLowerCase();

    const filtered = originalDataList.filter((item) => {
      
      if (item.action?.toLowerCase().includes(lowerSearch)) return true;
      if (item.user?.username?.toLowerCase().includes(lowerSearch)) return true;
      if (item.company?.name?.toLowerCase().includes(lowerSearch)) return true;
      if (item.callcenter?.name?.toLowerCase().includes(lowerSearch)) return true;
      if (item.created_at_formatted?.toLowerCase().includes(lowerSearch)) return true;

      const oldLic = item.old_licence || {};
      const newLic = item.updated_licence || {};

      for (const key of Object.keys(LICENCE_LABEL)) {
        if (String(oldLic[key] ?? "").toLowerCase().includes(lowerSearch)) return true;
        if (String(newLic[key] ?? "").toLowerCase().includes(lowerSearch)) return true;
      }

      return false;
    });

    setOperationList(filtered);
  }, [searchValue, originalDataList]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Licence History</h4>
              </div>
            </Card.Header>
            <Card.Body className="px-0">
              <div className="d-flex justify-content-between align-items-center mb-3 px-3 flex-wrap gap-3">
                <div className="flex-grow-1" style={{ maxWidth: "400px" }}>
                  <Form.Control
                    type="text"
                    placeholder="Search values..."
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                </div>

                {operationList.length > 0 && (
                  <Button
                    label="Export Data"
                    icon={buttonDisable ? "pi pi-spin pi-spinner" : "pi pi-download"}
                    onClick={handleExport}
                    className="p-button-sm"
                    disabled={buttonDisable}
                  />
                )}
              </div>

              <div
                className="table-responsive broad-scrollbar"
                style={{ overflowX: "auto" }}
              >
                <DataTable
                  value={operationList}
                  paginator
                  rows={10}
                  emptyMessage="No licence history found."
                  tableStyle={{ minWidth: "50rem" }}
                >
                  <Column field="key" header="#" style={{ width: "5%" }} />

                  <Column
                    header="Action"
                    body={(rowData) => (
                      <span
                        className={`badge bg-${
                          rowData.action === "created" ? "success" : "info"
                        }`}
                      >
                        {rowData.action?.toUpperCase()}
                      </span>
                    )}
                    style={{ width: "10%" }}
                  />

                  <Column
                    header="Changes"
                    body={licenceChangeBody}
                    style={{ width: "50%" }}
                  />

                  <Column
                    field="user.username"
                    header="Username"
                    style={{ width: "20%" }}
                  />
                  <Column
                    field="company.name"
                    header="Company"
                    style={{ width: "20%" }}
                  />
                  <Column
                    field="callcenter.name"
                    header="Call Center"
                    style={{ width: "20%" }}
                  />

                  <Column
                    field="created_at_formatted"
                    header="Date & Time"
                    style={{ width: "25%" }}
                  />
                </DataTable>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <style>
        {`
          .broad-scrollbar::-webkit-scrollbar {
            height: 10px;
          }
          .broad-scrollbar::-webkit-scrollbar-thumb {
            background-color: #888;
            border-radius: 10px;
          }
        `}
      </style>
    </>
  );
}